<template>
  <div class="pub_search">
    <div class="container1 pub_content">
      <div class="logo">
        <router-link to="/" target="_blank">
          <img class="img_item" src="@/assets/img/LOGO.png" alt />
        </router-link>
        <h1>买家具多比·多比多实惠</h1>
      </div>

      <div class="search_Goods">
        <div class="seach_box">
          <el-input :placeholder="keyWordsTips" v-model="query.searchKey" :clearable="true" @keyup.enter.native="searchKeyWords">
          </el-input>
          <el-button type="primary" @click="searchKeyWords">搜索</el-button>
        </div>
        <span class="hot">
          <router-link :to="{path:'/category',query: { categorySerNo: 9 }}" target="_blank">
            <span>沙发</span>
          </router-link>
          <router-link :to="{path:'/category',query: { categorySerNo: 28 }}" target="_blank">
            <span>床</span>
          </router-link>
          <router-link :to="{path:'/category',query: { categorySerNo: 26 }}" target="_blank">
            <span>床垫</span>
          </router-link>
          <router-link :to="{path:'/category',query: { categorySerNo: 36 }}" target="_blank">
            <span>餐桌</span>
          </router-link>
        </span>
      </div>

      <div class="my_cart">
        <el-badge @click.native="goRequirePage('/shopCart')" class="cart" :value="shoppingCartList.length" :max="99">
          <span class="test">我的购物车</span>
          <i class="el-icon-shopping-cart-full cart_icon"></i>
        </el-badge>
        <div class="content" v-if="false">
          <div class="shop_header"></div>
          <div class="shop_body">
            <div class="item" v-for="(v,i) in shoppingCartList" :key="i">
              <div class="img">
                <router-link :to="{path:'/goodsDetails/'+v.goodsMixSerNo+'.html'}" target="_blank">
                  <img v-lazy="v.mainPreviewImageFilePath" />
                </router-link>
              </div>
              <div class="itr">
                <router-link :to="{path:'/goodsDetails/'+v.goodsMixSerNo+'.html'}" target="_blank">
                  <p class="name">{{v.goodsMixName + v.goodsName }}</p>
                </router-link>
                <p class="price">
                  <span class="pr">￥{{v.salePrice}}</span>
                  <span>×{{v.goodsCount}}</span>
                  <a class="del" @click="delShoppingCart(v.id)">删除</a>
                </p>
              </div>
            </div>
            <div class="no_data" v-if="shoppingCartList.length===0">
              <img :src="cartSrc">
              <span>购物车还没有商品，赶紧选购吧！</span>
            </div>
          </div>
          <div class="shop_footer">
            <p>共{{shoppingCartList.length}}件商品，共计￥
              <span class="total">{{total}}</span>
            </p>
            <el-button type="primary">
              <router-link to="/shopCart" target="_blank"> 去购物车结算 </router-link>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetShopCartList,
  DelShopCart,
} from "@/pages/page1/api/modules/shoppingCart";
export default {
  name: "publicSearch",
  data() {
    return {
      keyWordsTips: "搜索分类/风格/材质/关键词等商品",
      isSearch: true,
      shoppingCartList: [],
      total: 0,
      cartSrc: require("@/assets/img/rightMenu3.png"),
      query: {
        searchKey: "",
      },
    };
  },
  mounted() {
    let path = this.$route.path;
    if (path === "/category") {
      Object.assign(this.query, this.$route.query);
      // console.log(this.query);
      this.isSearch = true;
    } else {
      this.isSearch = false;
    }
    if (this.$cookies.isKey("ACCESS_TOKEN")) {
      this.getShoppingCart();
    }
  },
  methods: {
    // 去需要登录的页面
    goRequirePage(path) {
      if (this.$cookies.isKey("ACCESS_TOKEN")) {
        let newUrl = this.$router.resolve(path);
        window.open(newUrl.href, "_blank");
      } else {
        this.goWithRedirect(path);
      }
    },
    // 去登录页 或者注册页带重定向地址
    goWithRedirect(path, register) {
      let newUrl = this.$router.resolve({
        path: register ? "/register" : "/login",
        query: {
          redirect: path,
        },
      });
      window.open(newUrl.href, "_self");
    },
    searchKeyWords() {
      // 手动删除后''
      this.query.searchKey = this.query.searchKey
        ? this.query.searchKey.trim()
        : undefined;
      let newUrl = this.$router.resolve({
        path: "/category",
        query: this.query,
      });
      if (this.isSearch) {
        window.open(newUrl.href, "_self");
      } else {
        window.open(newUrl.href, "_blank");
      }
    },
    getShoppingCart() {
      GetShopCartList({}).then((res) => {
        let arr = [];
        let total = 0;
        // console.log("获取购物车列表", res);
        res.data.forEach((v) => {
          v.shoppingCartList.forEach((item) => {
            arr.push(item);
            total += item.salePrice * item.goodsCount;
          });
        });
        this.total = total;
        this.shoppingCartList = arr;
        // console.log(this.shoppingCartList);
      });
    },
    delShoppingCart(id) {
      DelShopCart({ id }).then((res) => {
        // console.log("删除购物车记录接口", res);
        this.getShoppingCart();
      });
    },
  },
  // 购物车数量变化
  computed: {
    shoppingCartNum() {
      return this.$store.state.shoppingCartNum;
    },
  },
  watch: {
    shoppingCartNum(newV) {
      // console.log("变化", newV);
      this.getShoppingCart();
    },
  },
};
</script>

<style lang="less" scoped>
.pub_search {
  width: 100%;
  background: #ffffff;
  .pub_content {
    padding: 37px 0 43px;
    color: #333333;
    display: flex;
    justify-content: space-between;
  }
  .logo,
  .search_Goods {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .logo {
    width: 222px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    .img_item {
      width: auto;
      height: auto;
    }
    h1 {
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 5.6px;
    }
  }
  .search_Goods {
    align-self: flex-end;
    width: 506px;
    height: 54px;
    font-size: 14px;
    box-sizing: border-box;
    .seach_box {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      /deep/ .el-input {
        width: 440px;
        height: 32px;
        .el-input__inner {
          padding-right: 60px;
          border-color: @themeColor;
          height: 32px;
          line-height: 32px;
          font-size: 12px;
        }
        .el-input__clear {
          line-height: 32px;
        }
      }
      /deep/ .el-button {
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
        border-radius: 0;
        padding: 0;
        width: calc(100% - 440px);
        height: 32px;
      }
    }
    .hot {
      font-size: 12px;
      line-height: 12px;
      font-weight: 400;
      color: #bfbfbf;
      a {
        color: #bfbfbf;
        span {
          padding-right: 6px;
        }
      }
    }
  }
  .my_cart {
    align-self: flex-end;
    margin-bottom: 22px;
    width: 160px;
    height: 32px;
    font-size: 14px;
    font-weight: 500;
    position: relative;
    .cart {
      border: 1px solid #f6f6f6;
      height: 100%;
      box-sizing: border-box;
      color: #333333;
      padding-left: 15px;
      display: flex;
      align-items: center;
      cursor: pointer;
      &:hover {
        color: @themeColor !important;
        border-color: @themeColor !important;
      }
      .test {
        padding-right: 27px;
      }
      .cart_icon {
        font-size: 24px;
      }
      /deep/ .el-badge__content {
        background-color: @themeColor2;
        padding: 0 4px;
      }
      /deep/ .el-badge__content.is-fixed {
        top: 6px;
        right: 34px;
      }
    }
    .content {
      width: 320px;
      height: 140px;
      background: #ffffff;
      position: absolute;
      top: 100%;
      right: 0;
      z-index: 3;
      display: none;

      font-size: 12px;
      font-weight: 500;
      color: #787878;
      .shop_header {
        height: 10px;
        position: relative;
        z-index: 2;
        &::before {
          display: block;
          content: "";
          width: 0;
          height: 0;
          position: absolute;
          right: 30px;
          bottom: 0px;
          border-width: 8px;
          border-style: solid;
          border-color: transparent transparent #f6f6f6 transparent;
        }
        &::after {
          display: block;
          content: "";
          width: 0;
          height: 0;
          position: absolute;
          right: 30px;
          bottom: -2px;
          border-width: 8px;
          border-style: solid;
          border-color: transparent transparent #ffffff transparent;
        }
      }
      .shop_body {
        max-height: 254px;
        background-color: #fff;
        overflow: auto;
        border: 1px solid #f6f6f6;
        border-bottom: none;
        box-sizing: border-box;
        padding: 0 20px;
        .item {
          display: flex;
          padding: 10px 0;
          border-bottom: dotted 1px #ddd;
          .img {
            width: 45px;
            height: 45px;
            margin-right: 10px;
          }
          .itr {
            display: block;
            width: calc(100% - 55px);
            line-height: 18px;
            a {
              color: #787878;
            }
            .name {
              margin-top: 4px;
              height: 18px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .price {
              margin-top: 4px;
              color: #999999;
              .pr {
                color: #ff0000;
                padding-right: 2px;
              }
              .del {
                float: right;
                color: #999999;
                cursor: pointer;
              }
            }
          }
        }
        .no_data {
          line-height: 90px;
          text-align: center;
          img {
            width: auto;
            height: auto;
            margin-right: 14px;
            vertical-align: middle;
          }
        }
      }
      .shop_footer {
        background-color: #f6f6f6;
        height: 38px;
        padding: 0 15px;
        border: 1px solid #f6f6f6;
        border-top: none;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .total {
          font-size: 16px;
          color: #ff0000;
        }
        .el-button {
          padding: 0;
          width: 100px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          border-radius: 6px;

          font-size: 12px;
          font-weight: bold;
          color: #f6f6f6;
          a {
            color: #f6f6f6;
            &:hover {
              color: #ffffff !important;
            }
          }
        }
      }
    }
    &:hover {
      .content {
        display: block;
      }
    }
  }
}
</style>